import { render, staticRenderFns } from "./CredorEdit.vue?vue&type=template&id=c64755e2"
import script from "./CredorEdit.vue?vue&type=script&lang=js"
export * from "./CredorEdit.vue?vue&type=script&lang=js"
import style0 from "./CredorEdit.vue?vue&type=style&index=0&id=c64755e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports